import React from "react";
import { useTranslation } from "react-i18next";
import { FullSplitDnsResolver } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteResolverDialog}
 */
export type DeleteResolverDialogProps = {
    /** The Resolver */
    resolver: FullSplitDnsResolver | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
};

/**
 * A dialog to delete a resolver
 */
export default function DeleteResolverDialog(props: DeleteResolverDialogProps) {
    const [t] = useTranslation("dialog-delete-split-dns");

    if (!props.resolver) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.resolver) return;
                await ApiInternal.dns.deleteResolverSplitDns(props.resolver.uuid);
                notify.success(t("toast.successfully-deleted-resolver"));
                props.onDeletion();
            }}
            title={t("heading.delete-resolver")}
            confirmLabel={t("button.delete")}
            cancelLabel={t("button.cancel")}
        />
    );
}
